import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/android': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M420.6 301.9c-13.2 0-24-10.8-24-24s10.8-24 24-24 24 10.8 24 24-10.8 24-24 24zM155.4 301.9c-13.2 0-24-10.8-24-24s10.8-24 24-24 24 10.8 24 24-10.8 24-24 24zM429.1 157.4l47.9-83c1.1-1.6 1.7-3.5 1.7-5.6 0-5.5-4.5-10-10-10-3.9 0-7.3 2.3-9 5.6v0l-48.5 84.1c-37.6-16.9-79.2-26.2-123-26.2-43.8 0-85.9 9.4-123.5 26.2l-48.5-84.1c-1.6-3.3-5-5.6-9-5.6-5.5 0-10 4.5-10 10 0 2.1 0.6 4 1.7 5.6v0l47.9 83c-82.3 44.8-138.6 128.1-146.8 226.6h576c-8.2-98.5-64.5-181.8-146.8-226.6z'
      }
    ]
  }
})
